module.exports = __webpack_public_path__ + "static/media/bewal2.6eb17038.jpg";